import { createSelector } from '@reduxjs/toolkit';
import { selectTabs } from '~store/selectors';

export const selectPanelByPath = (path: string) =>
  createSelector(selectTabs, (tabs) => {
    return tabs.find((tab) => tab.path === path)?.view?.panel;
  });
